module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAABRElEQVQ4T5WTPUsDQRCGb1GMoFiZxiaIhVZGSCtJl9SJpgmWFmojiKSUWPgTxNqUgdgkJJDGIkUa9RekSSHYSbDzg/MZmZPNucmdCy8zu7zz3NzenPF9/9zzvBpaQrJeUMUYc6/7yGCAvOFaDjl7QAqR1WoQyJB8I1Twyj4J6CsOSCB3GIsOcxZIPy7kCOONw7wHRB4QuaSTNVwjNG+5W+QlIJ+RBAxGTIAahLIWfBDXATzHAYgngGyTP6E5LWwC2f8XRLu5Jp5YhZeAanFAP50oRIbtAW0FR8QrdAHMV8+udj+w7+sXoiYByGddtTpokx8jmexTPR8TH1Ed2O0EREEZYhclLdA7+YLj1aTDzT8QBckEN1HaURg+yjkhCkrIfaAztDgDNh0SFDFDKfIqOkArDlhmaidhMzD50/OqHaLAO+jwG2WNXda+9q4yAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dh.png
// module id = FPSN
// module chunks = 15